// Endpoints do Calendário Acadêmico Dinâmico.
// Módulo registrado como `dynamicCalendar` no registro central de serviços.
const services = {
    // Calendários acadêmicos (contêiner)
    indexAcademicCalendars:  { method: 'get',    url: 'academic_calendars' },
    showAcademicCalendar:    { method: 'get',    url: 'academic_calendars/{id}' },
    storeAcademicCalendar:   { method: 'post',   url: 'academic_calendars' },
    updateAcademicCalendar:  { method: 'put',    url: 'academic_calendars/{id}' },
    deleteAcademicCalendar:  { method: 'delete', url: 'academic_calendars/{id}' },

    // Cenários (variações de um calendário)
    indexCalendarScenarios:  { method: 'get',    url: 'calendar_scenarios' },
    showCalendarScenario:    { method: 'get',    url: 'calendar_scenarios/{id}' },
    storeCalendarScenario:   { method: 'post',   url: 'calendar_scenarios' },
    updateCalendarScenario:  { method: 'put',    url: 'calendar_scenarios/{id}' },
    deleteCalendarScenario:  { method: 'delete', url: 'calendar_scenarios/{id}' },
    scenarioMetrics:         { method: 'get',    url: 'calendar_scenarios/{id}/metrics' },
    calendarCoverage:        { method: 'get',    url: 'academic_calendars/{id}/coverage' },

    // Eventos vinculados ao calendário dinâmico
    indexCalendarEvents:     { method: 'get',    url: 'academic_calendars/{calendar}/events' },
    storeCalendarEvent:      { method: 'post',   url: 'academic_calendars/{calendar}/events' },
    updateCalendarEvent:     { method: 'put',    url: 'academic_calendars/{calendar}/events/{event}' },
    deleteCalendarEvent:     { method: 'delete', url: 'academic_calendars/{calendar}/events/{event}' },

    // Acesso / permissões (Etapa 9)
    calendarAccess:          { method: 'get',    url: 'dynamic-calendar/access' },
    calendarRoles:           { method: 'get',    url: 'dynamic-calendar/roles' },
    syncRolePermissions:     { method: 'put',    url: 'dynamic-calendar/roles/{id}/permissions' },
    saveRoleScope:           { method: 'put',    url: 'dynamic-calendar/roles/{id}/scope' },
    roleUsers:               { method: 'get',    url: 'roles/{id}/users' },
    searchInstitutionUsers:  { method: 'get',    url: 'users/institution' },
    attachUserRole:          { method: 'post',   url: 'user_roles' },
    revokeUserRole:          { method: 'post',   url: 'user_roles/revoke' },
    createRole:              { method: 'post',   url: 'roles' },
    attachCalendarRole:      { method: 'post',   url: 'dynamic-calendar/roles/{id}/attach' },
    detachCalendarRole:      { method: 'post',   url: 'dynamic-calendar/roles/{id}/detach' },

    // Configurações e indicadores (Fase 10)
    calendarSettings:        { method: 'get',    url: 'dynamic-calendar/settings' },
    saveCalendarSettings:    { method: 'put',    url: 'dynamic-calendar/settings' },
    calendarIndicators:      { method: 'get',    url: 'dynamic-calendar/indicators' },
    managerSummary:          { method: 'get',    url: 'dynamic-calendar/manager/summary' },

    // Assistente de agendamento (Python, Etapa 2)
    enqueueScheduling:       { method: 'post',   url: 'dynamic-calendar/scheduling' },
    schedulingSuggestions:   { method: 'get',    url: 'dynamic-calendar/scheduling/{runId}/suggestions' },
    algorithmRun:            { method: 'get',    url: 'algorithm/runs/{runId}' },

    // Otimizador de cobertura (Python, Cobertura)
    enqueueCoverageOpt:      { method: 'post',   url: 'dynamic-calendar/coverage-opt' },
    coverageOptSuggestions:  { method: 'get',    url: 'dynamic-calendar/coverage-opt/{runId}/suggestions' },
    applyCoverageOpt:        { method: 'put',    url: 'dynamic-calendar/coverage-opt/scenario/{scenarioId}/apply' },
    getScopedDays:           { method: 'get',    url: 'dynamic-calendar/scenario/{scenarioId}/scoped-days' },
    setScopedDays:           { method: 'put',    url: 'dynamic-calendar/scenario/{scenarioId}/scoped-days' },

    // Publicação e alterações (Etapa 4)
    publishCalendar:         { method: 'put',    url: 'academic_calendars/{id}/publish' },
    indexChangeRequests:     { method: 'get',    url: 'academic_calendars/{calendar}/change-requests' },
    storeChangeRequest:      { method: 'post',   url: 'academic_calendars/{calendar}/change-requests' },
    respondChangeRequest:    { method: 'put',    url: 'calendar_change_requests/{id}/respond' },
    publishChangeRequest:    { method: 'put',    url: 'calendar_change_requests/{id}/publish' },
    deleteChangeRequest:     { method: 'delete', url: 'calendar_change_requests/{id}' },

    // Aprovação (Etapa 3)
    indexApprovals:          { method: 'get',    url: 'academic_calendars/{calendar}/approvals' },
    approveStep:             { method: 'put',    url: 'academic_calendars/{calendar}/events/{event}/approval' },
    approveBatch:            { method: 'put',    url: 'academic_calendars/{calendar}/approvals/batch' },
    reopenApproval:          { method: 'put',    url: 'academic_calendars/{calendar}/events/{event}/approval/reopen' },
    approvalAck:             { method: 'put',    url: 'academic_calendars/{calendar}/approvals/ack' },

    // Considerações (Etapa 2)
    indexConsiderations:     { method: 'get',    url: 'academic_calendars/{calendar}/considerations' },
    storeConsideration:      { method: 'post',   url: 'academic_calendars/{calendar}/considerations' },
    updateConsideration:     { method: 'put',    url: 'calendar_considerations/{id}' },
    deleteConsideration:     { method: 'delete', url: 'calendar_considerations/{id}' },

    // Catálogos reaproveitados
    indexEventCalendars:     { method: 'get',    url: 'event_calendars' },
    indexHolidays:           { method: 'get',    url: 'event_calendars/holidays' },
    indexWorkTimes:          { method: 'get',    url: 'work_times' },
    eventTypes:              { method: 'get',    url: 'event_types' },
    eventCategories:         { method: 'get',    url: 'event_categories' },
    eventPublics:            { method: 'get',    url: 'event_publics' },
    eventAreas:              { method: 'get',    url: 'event_areas' },
    eventScopes:             { method: 'get',    url: 'event_scopes' },
    brands:                  { method: 'get',    url: 'brands' },
    states:                  { method: 'get',    url: 'states' },
    campuses:                { method: 'get',    url: 'campuses' },
    courses:                 { method: 'get',    url: 'courses' },
    courseModalities:        { method: 'get',    url: 'courses/modalities' },
    groups:                  { method: 'get',    url: 'groups' },
}

export default { dynamicCalendar: services }
